import { fetchWithAuth } from "../utils/apiUtils";

export interface Organization {
    _id: string;
    name: string;
    phoneNumber?: string;
    email?: string;
    subscriptionStatus?: string;
}

export interface CurrentOrganizationResponse {
    organization: Organization;
    hasSelectedOrganization?: boolean;
}

export default class SuperAdminService {
    private static superAdminPath = 'auth/super-admin';

    constructor() { }

    public static async getOrganizations() {
        return await fetchWithAuth(`${this.superAdminPath}/organizations`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async selectOrganization(organizationId: string) {
        return await fetchWithAuth(`${this.superAdminPath}/select-organization`, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({ organizationId })
        });
    }

    public static async getCurrentOrganization() {
        return await fetchWithAuth(`${this.superAdminPath}/current-organization`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async clearOrganization() {
        return await fetchWithAuth(`${this.superAdminPath}/clear-organization`, {
            method: 'DELETE',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }
}
